// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';
import { BoosterButtonLayout } from './boosters/BoosterButtonLayout';

const raw = {
  list: [
    {
      id: '2c2bc6fb-6504-44f7-a552-86f7386ffd6a',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        bundlesToPreload: {
          testAtlas: [
            {
              alias: [
                'testAtlas69'
              ],
              src: [
                'http://192.168.1.212:8080/test.png.json',
                'http://192.168.1.212:8080/test.avif.json',
                'http://192.168.1.212:8080/test.webp.json'
              ],
              data: {
                tags: {
                  tps: true,
                  m: true
                }
              }
            }
          ]
        }
      }
    },
    {
      id: '7217f356-d30a-4f97-ba70-fbb32b7de228',
      type: 'Sprite',
      name: 'coin',
      className: '',
      x: 50,
      y: 106,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_3',
      mask: null,
      parent: '2c2bc6fb-6504-44f7-a552-86f7386ffd6a'
    },
    {
      id: 'c7e37035-ea30-42a1-a4ed-1e9a596e1d22',
      type: 'Layout',
      name: '',
      className: '',
      path: 'boosters/BoosterButtonLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 352,
      y: 303,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '2c2bc6fb-6504-44f7-a552-86f7386ffd6a',
      stateByName: {
        undo: {
          skin: 'undo-enabled'
        }
      }
    },
    {
      id: 'fd9b4af9-3f2e-45a1-afe9-854d92a6deba',
      type: 'Sprite',
      name: '',
      className: '',
      x: 359,
      y: -29,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'More_Offer_Back_to_Top_Blue_Button_Background',
      mask: null,
      parent: '2c2bc6fb-6504-44f7-a552-86f7386ffd6a',
      stateByName: {
        undo: {
          texture: 'Coins_4'
        }
      }
    },
    {
      id: '4f512c3e-cab5-40ce-b6dd-8c9cff844873',
      type: 'Sprite',
      name: '',
      className: '',
      x: 42,
      y: 172,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_6_Gingerbread_Man',
      mask: null,
      parent: '2c2bc6fb-6504-44f7-a552-86f7386ffd6a'
    },
    {
      id: '84adef35-9761-44ad-96b8-a403efe05d41',
      type: 'Sprite',
      name: 'planeBear',
      className: '',
      x: 543,
      y: 130,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Plane',
      mask: null,
      parent: '2c2bc6fb-6504-44f7-a552-86f7386ffd6a',
      stateByName: {
        undo: {
          texture: 'Diorama_3_Bear_Bridge'
        }
      }
    },
    {
      id: '36387350-fa0a-4068-aa93-f5f352b90f32',
      type: 'Sprite',
      name: '',
      className: '',
      x: -36,
      y: 177,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_5_Carrousel',
      mask: null,
      parent: '2c2bc6fb-6504-44f7-a552-86f7386ffd6a'
    },
    {
      id: '38a90391-6f6b-40ad-ad06-952f1edda2b6',
      type: 'Text',
      name: '',
      className: '',
      x: 200,
      y: 15,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'en',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '2c2bc6fb-6504-44f7-a552-86f7386ffd6a',
      data: {
        translations: {
          en_US: 'en',
          pl_PL: 'pl'
        }
      }
    },
    {
      id: '7c1e74d4-5f0d-4920-b21b-063fa9e60626',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lego-71427',
      parent: '2c2bc6fb-6504-44f7-a552-86f7386ffd6a',
      data: {
        url: 'http://192.168.1.212:8080/lego-71427.jpg'
      }
    },
    {
      id: '406839d0-02c2-43cb-af3e-02f596dbcb61',
      type: 'Sprite',
      name: '',
      className: '',
      x: 99,
      y: 351,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'bubble_mega_bomb',
      parent: '2c2bc6fb-6504-44f7-a552-86f7386ffd6a'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'undo'
  ],
  animations: [
    {
      id: 'a081221d-4d45-4316-82d2-086f4487d377',
      name: 'Animation1',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: '73dfc593-8df6-43a1-bfe2-b5b4f33dd56f',
          type: 'Setter',
          name: 'New_setter',
          track: 1,
          target: {
            textureName: 'Coins_1'
          },
          startAt: 485,
          sourceName: 'coin',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class Test1 {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  coin!: Sprite;
  planeBear!: Sprite;
  StateName!: 'undo';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Animation1 {
  Layout: {
    coin: object;
  };

  BlockTypeByName: {
    New_setter: object;
  };

  flowData = raw.animations[0];
}
